import { turboproApi } from '@/api/turbopro';
import type { GerarRelatorioCSVResponse, GerarRelatorioPayload } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function gerarRelatorioCsvApi(
  payload: GerarRelatorioPayload
): Promise<GerarRelatorioCSVResponse> {
  const resposta = await turboproApi<GerarRelatorioCSVResponse>('Relatorios/GerarRelatorioCSV', {
    method: 'POST',
    body: payload,
    headers: getRelatoriosHeaders(),
  });
  return resposta.data;
}
